import { ToastContainer, Slide, toast } from 'react-toastify';

interface ToastProps {
  topInset?: number;
}

const Toast = ({ topInset }: ToastProps) => {
  return (
    <ToastContainer
      position="top-center"
      autoClose={2000}
      toastClassName={() =>
        'mx-auto w-fit max-w-[calc(100vw-40px)] rounded-[4px] bg-gr-800/80 px-[16px] py-[13px] text-center text-white Body5M14'
      }
      toastStyle={{
        marginTop: topInset,
      }}
      transition={Slide}
      closeButton={false}
      hideProgressBar={true}
      onClick={() => toast.dismiss()}
      limit={2}
    />
  );
};

export default Toast;
